import React, { useEffect } from 'react';
import './App.css';
import 'fontsource-roboto';

import { createTheme, ThemeProvider, makeStyles } from '@material-ui/core/styles';

import Login from './sections/login/Login';
import Nav1 from './sections/navs/nav1';
import LoadingScreen from './components/LoadingScreen'
import Parse from 'parse';
import firebase from 'firebase/compat/app'
import { getFromAPI } from './sections/helpers/sqlApiCalls';

firebase.initializeApp({
  apiKey: "AIzaSyA5At-gUPPwB6wZ5THxraYUMdkOuKxa2IE",
  authDomain: "lusqtoffb2b.firebaseapp.com",
  databaseURL: "https://lusqtoffb2b.firebaseio.com",
  projectId: "lusqtoffb2b",
  storageBucket: "lusqtoffb2b.appspot.com",
  messagingSenderId: "218222263516",
  appId: "1:218222263516:web:0f5932d395bd8284c90819"
});

Parse.initialize("myAppId", "myAppId");
//javascriptKey is required only if you have it on server.
Parse.serverURL = 'http://164.90.134.205:1337/parse';

localStorage.env = "snLts1zpQu"
localStorage.envId = "snLts1zpQu"
localStorage.articulos = ""
localStorage.historialPedidos = ""
localStorage.historialCobranzas = ""
localStorage.currencyValue = ""

localStorage.defaultConfig = JSON.stringify({ "defaultDeposit": "1", "maxLines": 20 })
/**
 * Paleta de colores
 * #676767    Header
 * #CCCBCB    AppBar
 * #0f5591    Botones
  Botones e iconos
 */
const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#0f5591',
      dark: '#0f5591',
      contrastText: '#FFF',
    },
    secondary: {
      light: '#ff7961',
      main: '#0f5591',
      dark: '#0f5591',
      contrastText: '#FFF',
    },
    nav1: {
      actions: '#0f5591',
      header: '#676767',
      app: '#CCCBCB',
      text: '#FFF',
    }
  },
});

const themen1 = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#0f5591',
      dark: '#0f5591',
      contrastText: '#000',
    },
    secondary: {
      light: '#ff7961',
      main: '#0f5591',
      dark: '#0f5591',
      contrastText: '#FFF',
    },
    third: {
      light: '#4373ba',
      main: '#4373ba',
      dark: '#4373ba',
      contrastText: '#FFF',
    },
    nav: {
      actions: '#0f5591',
      header: '#676767',
      app: '#CCCBCB',
      text: '#FFF',
    }
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  iconPadded: {
    marginRight: 10
  }
}));

function App() {

  const classes = useStyles();

  // const [auth, setAuth] = React.useState(localStorage.clData && localStorage.clData.length > 0 && localStorage.sellerCode && localStorage.sellerCode.length > 0 && localStorage.stayLoggedIn === "true" ? true : false);
  const [auth, setAuth] = React.useState(false);
  const [loading, setLoading] = React.useState(true)

  // const [anchorEl, setAnchorEl] = React.useState(null);

  // const open = Boolean(anchorEl);

  // const handleChange = (event) => {
  //   setAuth(event.target.checked);
  // };

  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  useEffect(() => {

    const getMoney = async () => {
      const moneys = await getFromAPI("Moneys")
      let fecha = Date.now()
      let fmoney = 0
      let v = 1
      for (let element of moneys) {
        if (element.t < fecha && element.t > fmoney) {
          fmoney = element.t
          v = element.v
        }
      }
      localStorage.currencyValue = "" + v
    }
    getMoney()
  })

  useEffect(() => {

    const getLicenseSettings = async () => {

      try {
        const query = new Parse.Query("LicenseSettings");

        query.equalTo("envId", localStorage.envId);
        query.equalTo("license", "conquerDefault");
        const response = await query.first();

        localStorage.defaultConfig = JSON.stringify({
          ...JSON.parse(localStorage.defaultConfig),
          ...response.attributes.settings
        })


      }
      catch (error) {
        console.log('error', error)
      }

    }
    getLicenseSettings()
  })

  useEffect(() => {
    // declare the data fetching function
    const validateUser = async () => {
      if (typeof window !== 'undefined') {
        const user = JSON.parse(window.localStorage.getItem('user'))
        const Customers = Parse.Object.extend("RegisteredCustomers");
        const query = new Parse.Query(Customers);
        query.equalTo("objectId", user.id);
        query.equalTo("envId", user.envId);
        query.equalTo("p", user.p)
        query.equalTo("e", user.e)
        const result = await query.first();

        if (result) {
          localStorage.client = result.get('k')
          localStorage.user = JSON.stringify({ ...result.attributes, id: result.id })
          const client = await getFromAPI("Clients", `k=${localStorage.client}`)
          const clientSellers = client[0].s
          const seller = await getFromAPI("Sellers", `k=${Object.keys(clientSellers)[0]}`)
          localStorage.sellerCode = Object.keys(clientSellers)[0]
          localStorage.sellerName = seller[0].n
          localStorage.clData = JSON.stringify({ "pl": client[0].pl, "sc": client[0].sc })
          localStorage.clInfo = JSON.stringify(client[0])
          localStorage.admin = result.get('admin') ? true : false
        }

        if (result && localStorage.clData && localStorage.clData.length > 0 && localStorage.sellerCode && localStorage.sellerCode.length > 0 && localStorage.stayLoggedIn === "true") {
          setAuth(true)
        } else {
          setAuth(false)
        }
        setLoading(false)
      }
    }

    // call the function
    validateUser()
      // make sure to catch any error
      .catch((e) => {
        setLoading(false)
        console.log(e)
      }
      );
  }, [])

  return (
    <div className={classes.root}>
      {
        loading ?
          <ThemeProvider theme={themen1}>
            <LoadingScreen />
          </ThemeProvider>
          :
          auth ?
            <ThemeProvider theme={themen1}>
              <Nav1 Logout={() => { setAuth(false) }} />
            </ThemeProvider>
            :
            <ThemeProvider theme={theme}>
              <Login ValidateLogin={(x) => { setAuth(x) }} />
            </ThemeProvider>
      }
    </div>
  );
}

export default App;
